// ISO-3166 alpha-2 codes (for country-flag-icons) + Spanish names. Curated list
// of common footballing / sports nations; extend as needed.
export interface Country {
  code: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  { code: "ES", name: "España" },
  { code: "MX", name: "México" },
  { code: "AR", name: "Argentina" },
  { code: "BR", name: "Brasil" },
  { code: "US", name: "Estados Unidos" },
  { code: "GB", name: "Reino Unido" },
  { code: "PT", name: "Portugal" },
  { code: "FR", name: "Francia" },
  { code: "DE", name: "Alemania" },
  { code: "IT", name: "Italia" },
  { code: "NL", name: "Países Bajos" },
  { code: "BE", name: "Bélgica" },
  { code: "CH", name: "Suiza" },
  { code: "QA", name: "Catar" },
  { code: "JP", name: "Japón" },
  { code: "KR", name: "Corea del Sur" },
  { code: "MA", name: "Marruecos" },
  { code: "SN", name: "Senegal" },
  { code: "NG", name: "Nigeria" },
  { code: "EG", name: "Egipto" },
  { code: "CO", name: "Colombia" },
  { code: "CL", name: "Chile" },
  { code: "UY", name: "Uruguay" },
  { code: "PE", name: "Perú" },
  { code: "EC", name: "Ecuador" },
  { code: "PY", name: "Paraguay" },
  { code: "BO", name: "Bolivia" },
  { code: "VE", name: "Venezuela" },
  { code: "CR", name: "Costa Rica" },
  { code: "PA", name: "Panamá" },
  { code: "CA", name: "Canadá" },
  { code: "AU", name: "Australia" },
  { code: "HR", name: "Croacia" },
  { code: "RS", name: "Serbia" },
  { code: "PL", name: "Polonia" },
  { code: "DK", name: "Dinamarca" },
  { code: "SE", name: "Suecia" },
  { code: "NO", name: "Noruega" },
  { code: "TR", name: "Turquía" },
  { code: "GR", name: "Grecia" },
  { code: "SA", name: "Arabia Saudí" },
  { code: "IR", name: "Irán" },
  { code: "GH", name: "Ghana" },
  { code: "CM", name: "Camerún" },
  { code: "TN", name: "Túnez" },
  { code: "CI", name: "Costa de Marfil" },
  { code: "DZ", name: "Argelia" },
  { code: "AT", name: "Austria" },
  { code: "CZ", name: "Chequia" },
  { code: "UA", name: "Ucrania" },
  { code: "SCcustom", name: "Escocia" },
];

// Escocia/Inglaterra/Gales no tienen alpha-2 ISO; mapeamos a GB como fallback.
export const FLAG_FALLBACK: Record<string, string> = { SCcustom: "GB" };

export function flagCode(code: string): string {
  return FLAG_FALLBACK[code] ?? code;
}

// National-team name (Spanish, accent-insensitive) → ISO-2, for auto-assigning
// flags when importing selections. Clubs (no national flag) return null.
const TEAM_FLAGS: Record<string, string> = {
  espana: "ES", mexico: "MX", argentina: "AR", brasil: "BR", brazil: "BR",
  "estados unidos": "US", eeuu: "US", usa: "US", "reino unido": "GB", inglaterra: "GB",
  escocia: "GB", gales: "GB", portugal: "PT", francia: "FR", alemania: "DE", italia: "IT",
  "paises bajos": "NL", holanda: "NL", belgica: "BE", suiza: "CH", catar: "QA", qatar: "QA",
  japon: "JP", "corea del sur": "KR", marruecos: "MA", senegal: "SN", nigeria: "NG", egipto: "EG",
  colombia: "CO", chile: "CL", uruguay: "UY", peru: "PE", ecuador: "EC", paraguay: "PY",
  bolivia: "BO", venezuela: "VE", "costa rica": "CR", panama: "PA", canada: "CA", australia: "AU",
  croacia: "HR", serbia: "RS", polonia: "PL", dinamarca: "DK", suecia: "SE", noruega: "NO",
  turquia: "TR", grecia: "GR", "arabia saudi": "SA", "arabia saudita": "SA", iran: "IR",
  ghana: "GH", camerun: "CM", tunez: "TN", "costa de marfil": "CI", argelia: "DZ",
  austria: "AT", chequia: "CZ", "republica checa": "CZ", ucrania: "UA", rusia: "RU",
};

function normName(s: string): string {
  return (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();
}

export function teamFlag(name: string): string | null {
  return TEAM_FLAGS[normName(name)] ?? null;
}
